import { useMemo } from "react";

//components
import SystemMessage from "./SystemMessage";
import UserBotMessage from "./UserBotMessage";

const Message = ({ message, audioPlayedIdsRef }) => {
	const isCurrentUser = useMemo(
		() => message?.user_guid === window.__cng_common.user_guid,
		[message]
	);

	if (message.show_to_author === false && isCurrentUser) {
		return null;
	} else if (message.personal && !isCurrentUser) {
		return null;
	} else if (["bot", "user"].includes(message.type)) {
		return (
			<UserBotMessage
				message={message}
				isCurrentUser={isCurrentUser}
				audioPlayedIdsRef={audioPlayedIdsRef}
			/>
		);
	}
	return <SystemMessage message={message} />;
};

export default Message;
